import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { CoreMyntModal } from '../../modals/CoreMyntModal'
import { BorderContainer } from '../borderedContainer'

export interface CreateMandateBankaccountFormValues {
  bankAccount: string
  sendMandateAgreement: boolean
}

interface DirectDebitTabNewConnection {
  onCreateMandate: (data: CreateMandateBankaccountFormValues) => void
  isLoading?: boolean
}

export const CreateMandateBankaccount = ({ onCreateMandate, isLoading }: DirectDebitTabNewConnection) => {
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const handleSubmit = (data: CreateMandateBankaccountFormValues) => {
    onCreateMandate(data)
  }

  const form = useForm<CreateMandateBankaccountFormValues>({
    defaultValues: {
      bankAccount: '',
      sendMandateAgreement: true,
    },
  })

  const sendMandateAgreement = form.watch('sendMandateAgreement')

  return (
    <BorderContainer aria-label="bank-account" gap={3}>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          Add bank account number
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Set the customers bank account number for direct debit
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        <TextField {...form.register('bankAccount')} label="Bank account number" />
        <Box>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={sendMandateAgreement}
                onChange={(event) => {
                  form.setValue('sendMandateAgreement', event.target.checked)
                }}
              />
            }
            label={<Typography variant="body2">Send mandate agreement to customer</Typography>}
          />
        </Box>
        <Box>
          <Button
            disabled={isLoading}
            onClick={sendMandateAgreement ? form.handleSubmit(handleSubmit) : () => setShowConfirmModal(true)}
            variant="primary"
          >
            Create bank account
          </Button>
        </Box>
        <CoreMyntModal
          title="Are you sure?"
          open={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          actions={(Wrapper) => (
            <Wrapper>
              <Button onClick={() => setShowConfirmModal(false)}>Cancel</Button>
              <Button
                aria-label="mandate-modal-confirm"
                variant="primary"
                onClick={() => {
                  setShowConfirmModal(false)
                  form.handleSubmit(handleSubmit)()
                }}
              >
                Yes, proceed
              </Button>
            </Wrapper>
          )}
        >
          <Box maxWidth={400}>
            <Typography variant="body2" color="text.secondary">
              You are about to set up direct debit without sending a mandate agreement. This is not recommended
            </Typography>
          </Box>
        </CoreMyntModal>
      </Box>
    </BorderContainer>
  )
}
